import * as types from './v2DashboardTypes';

export const openV2Dashboard = () => ({
    type: types.OPEN_V2_DASHBOARD,
});

export const closeV2Dashboard = () => ({
    type: types.CLOSE_V2_DASHBOARD,
});
